import { render, staticRenderFns } from "./BasicInfomation.vue?vue&type=template&id=5983a7bd&scoped=true"
import script from "./BasicInfomation.vue?vue&type=script&lang=js"
export * from "./BasicInfomation.vue?vue&type=script&lang=js"
import style0 from "./BasicInfomation.vue?vue&type=style&index=0&id=5983a7bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983a7bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5983a7bd')) {
      api.createRecord('5983a7bd', component.options)
    } else {
      api.reload('5983a7bd', component.options)
    }
    module.hot.accept("./BasicInfomation.vue?vue&type=template&id=5983a7bd&scoped=true", function () {
      api.rerender('5983a7bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/BasicInfomation.vue"
export default component.exports